import { ArticleItem } from "./components/artical-items"
import { FeaturedArticleCard } from "./components/featured-artical-cards"

export default function Blog() {
  // Simple mock data to match the layout
  const featured = {
    title: "Why Every School Needs a 24/7 Virtual Admission Counselor",
    excerpt:
      "Parents today don't wait for office hours — their questions come anytime, anywhere. Our Virtual Admission Counselor works round the clock in multiple languages, answering FAQs, sharing brochures, and booking appointments.",
    date: "23/04/25",
    imageSrc: "/images/new-landing-page/blog1.png",
    imageAlt: "AI assistant illustration on phone",
  }

  const articles = [
    {
      title: "Social Media That Runs Itself",
      excerpt:
        "Imagine your school’s social media filled daily with celebrations and updates — without you lifting a finger.",
      date: "27/01/25",
      imageSrc: "/images/new-landing-page/blog2.png",
      imageAlt: "Social media icons",
    },
    {
      title: "The Power of Multilingual Parent Communication",
      excerpt: "Poor communication is a top reason families switch schools. Multilingual updates solve it.",
      date: "27/01/25",
      imageSrc: "/images/new-landing-page/blog3.png",
      imageAlt: "Language bubbles",
    },
    {
      title: "Inspire Students. Support Parents. Build Loyalty.",
      excerpt: "School isn't just academics — it's about inspiration and support. Stories build motivation.",
      date: "27/01/25",
      imageSrc: "/images/new-landing-page/blog4.png",
      imageAlt: "Happy students",
    },
    {
      title: "Smarter Admin. Happier Parents. Stronger Schools.",
      excerpt: "Automate reminders, attendance, homework tracking and more — without repetitive tasks.",
      date: "27/01/25",
      imageSrc: "/images/new-landing-page/blog5.png",
      imageAlt: "Automation concept",
    },
  ]

  return (
    <main className="mt-12">
      <header className="py-10 md:py-12">
        <h1 className="text-center text-balance text-5xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]">Blogs</h1>
      </header>

      <section className="mt-8 container mx-auto max-w-6xl laptop:max-w-7xl px-4 md:px-6 pb-16">
        <div className="grid gap-8 grid-cols-12 md:grid-cols-1 items-center">
          <div className="col-span-6 md:col-span-1">
            <FeaturedArticleCard {...featured} />
          </div>

          <aside className="col-span-6 md:col-span-1">
            <h2 className="text-sm font-medium text-foreground border-b-4 border-orange-500 pb-1">Featured Articles</h2>
            <div className="mt-2 h-px w-full bg-border" />
            <div className="mt-4 space-y-10">
              {articles.map((a, i) => (
                <ArticleItem key={i} {...a} />
              ))}
            </div>
          </aside>
        </div>
      </section>
    </main>
  )
}